/**
 * @fileoverview Vuex store module for Contacts CRM.
 */

import {
  getContacts,
  getContact,
  createContact,
  updateContact,
  deleteContact,
  getContactTags,
  addContactTag,
  removeContactTag,
  addContactNote,
  getContactTimeline,
} from "@/api/contacts";

const state = {
  contacts: [],
  currentContact: null,
  tags: [],
  timeline: [],
  totalElements: 0,
  totalPages: 0,
  page: 0,
  loading: false,
};

const mutations = {
  setContacts(state, { content, totalElements, totalPages, page }) {
    state.contacts = content;
    state.totalElements = totalElements;
    state.totalPages = totalPages;
    state.page = page;
  },
  setCurrentContact(state, contact) {
    state.currentContact = contact;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setTimeline(state, timeline) {
    state.timeline = timeline;
  },
  appendTimeline(state, activities) {
    state.timeline = state.timeline.concat(activities);
  },
  setLoading(state, val) {
    state.loading = val;
  },
  removeContact(state, id) {
    state.contacts = state.contacts.filter(function(c) { return (c._id || c.id) !== id; });
  },
};

const actions = {
  async loadContacts({ commit }, params) {
    commit('setLoading', true);
    try {
      var result = await getContacts(params);
      commit('setContacts', result);
    } catch (e) {
      console.error('Failed to load contacts:', e);
    } finally {
      commit('setLoading', false);
    }
  },

  async loadContact({ commit }, id) {
    try {
      var contact = await getContact(id);
      commit('setCurrentContact', contact);
      return contact;
    } catch (e) {
      console.error('Failed to load contact:', e);
    }
  },

  async saveContact(_, data) {
    return await createContact(data);
  },

  async editContact({ commit }, { id, data }) {
    var updated = await updateContact(id, data);
    commit('setCurrentContact', updated);
    return updated;
  },

  async removeContact({ commit }, id) {
    await deleteContact(id);
    commit('removeContact', id);
  },

  async loadTags({ commit }) {
    try {
      var tags = await getContactTags();
      commit('setTags', Array.isArray(tags) ? tags : []);
    } catch (e) {
      console.error('Failed to load tags:', e);
    }
  },

  async addTag({ commit }, { id, tag }) {
    var contact = await addContactTag(id, tag);
    commit('setCurrentContact', contact);
    return contact;
  },

  async removeTag({ commit }, { id, tag }) {
    var contact = await removeContactTag(id, tag);
    commit('setCurrentContact', contact);
    return contact;
  },

  async addNote({ commit }, { id, text }) {
    var contact = await addContactNote(id, text);
    commit('setCurrentContact', contact);
    return contact;
  },

  async loadTimeline({ commit }, { id, params }) {
    try {
      var result = await getContactTimeline(id, params);
      if (params && params.page > 0) {
        commit('appendTimeline', result.content);
      } else {
        commit('setTimeline', result.content);
      }
      return result;
    } catch (e) {
      console.error('Failed to load timeline:', e);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
